var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFechar01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_61",
    cx: 18,
    cy: 18,
    rx: 17.5,
    ry: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2539",
    transform: "translate(21.572 12.051) rotate(135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_466",
    x: 4.8,
    y: -11.4,
    className: "st0",
    width: 3.8,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_467",
    x: -3,
    y: -3.6,
    className: "st0",
    width: 19.5,
    height: 3.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFechar01);
export default __webpack_public_path__ + "static/media/ico-fechar-01.0955bf083b440939fb7d5317778462dd.svg";
export { ForwardRef as ReactComponent };